export interface CreateIssueThread {
  sellerWorkspaceId: string;
  messageId: string;
  description?: string;
  message?: string;
  customerInviteIds?: string[];
  customerId?: string;
  teamMembers?: IssueTeamMember[];
  channelId?: string;
  entityType?: string;
}

interface IssueTeamMember {
  inviteId: string;
  issueRole: IssueRole;
  role: ThreadMemberRole;
}

export enum IssueRole {
  ASSIGNED = 'assigned',
  WATCHER = 'watcher',
  CREATOR = 'creator',
}

export enum ThreadMemberRole {
  ADMIN = 'admin',
  MEMBER = 'member',
  CUSTOMER_ADMIN = 'customerAdmin',
}

export interface Thread {
  unreadMessageCount: number;
  description?: string;
  latestMessage?: string;
  channelType: string;
  channelSubType: string;
  channelName: string;
  messageId: string;
  workspaceId: string;
  companyName: string;
  customerId?: string;
  folderId?: string;
  id: string;
  createdAt: string;
  updatedAt: string;
  isDefault: boolean;
  channelId?: string;
  channelMembers: ThreadMember[];
}

export interface ThreadMember {
  addedBy: string;
  channelId: string;
  userId: string;
  teamMemberId?: string;
  id: string;
  createdAt: string;
  updatedAt: string;
  addedDate: string;
  isArchive: boolean;
  isRemoved: boolean;
  hasLeft: boolean;
  isEmailNotificationEnabled: boolean;
  isSmsNotificationEnabled: boolean;
  isAppNotificationEnabled: boolean;
  isWebNotificationEnabled: boolean;
  customerId?: string;
}

export interface SearchThreadsResponse {
  teamMembers: ThreadMemberItem[];
  customerThreads?: SearchCustomerItem[];
  groupsAndIssueThreads: ThreadItem[];
}

interface ThreadFilterCustomer {
  id: string;
  phone: string;
  phone2: string;
  isActive: number;
  isArchive: number;
  email: string;
  customerCode: string;
  gstin: string;
  name: string;
  companyName: string;
  distributorCode: string;
  languageCode: string;
}
export interface SearchCustomerItem {
  channelSubType: null | string;
  channelType: null | string;
  id: string;
  phone: string;
  customerId: string;
  channelName: string;
  createdAt: string;
  name: string;
  distributorCode: string;
  companyName: string;
  customer: ThreadFilterCustomer;
  spaceName: string;
}

export interface CustomerThreadItem {
  channel_channelSubType: string | null;
  inviteId: string;
  phone: string;
  channelSubType: null | string;
  channelType: null | string;
  channelId: string | null;
  channelName: string | null;
  createdAt: string;
  name: string;
  distributorCode: string;
  companyName: string;
}

interface ThreadItem {
  id: string;
  createdAt: string;
  channelName: string;
  channelSubType: string;
  channelMembers: ThreadChannelMember[];
}

interface ThreadMemberItem {
  inviteId: string;
  inviteStatus: string;
  inviteType: string;
  userEmail: string;
  userFirstName: string;
  userId: string;
  userLastName: string;
  userMobile: string;
}

interface ThreadChannelMember {
  id: string;
  userId: string;
}

export interface UpdateThreadStateResponse {
  id: string;
  isActive: boolean;
  issueStatus: IssueStatus;
  customerId: null;
  workspaceId: null;
  folderId: null;
  updatedAt: string;
}

export interface CreateCustomerThreadResonse {
  id: string;
  phone: string;
  senderUserId: string;
  senderWorkspaceId: string;
  customerDetails: CustomerDetails;
  status: string;
  createdDate: string;
  updatedDate: string;
  customerGroups: CustomerGroups;
  customerThread: CustomerThread;
}
interface CustomerThread {
  customerId: string;
  workspaceId: string;
  channelType: string;
  channelName: string;
  enableWhatsappNotification: boolean;
  folderId: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
  isDefault: boolean;
}
interface CustomerGroups {
  // Todo
}

interface CustomerDetails {
  id: string;
  inviteId: string;
  name: string;
  email: string;
  companyName: string;
  gstin: string;
  businessPAN: string;
  distributorCode: string;
  postalCode: string;
  physicalAddress: PhysicalAddress;
  shippingAddress: ShippingAddress;
  distributorChannel: string;
  CSTNumber: string;
  telephone: string;
  token: string;
  cityId: string;
  districtId: string;
  cityName: string;
  createdDate: string;
  updatedDate: string;
  dlExpiry: string;
  dlNumber: string;
  grossCreditLimit: number;
  creditLimitPeriod: number;
  tags: string;
  fulfillmentLocationCode: string;
  countryId: string;
  stateId: string;
}

interface PhysicalAddress {
  address1: string;
  address2: string;
}

interface ShippingAddress {
  shippingAddress1: string;
  shippingAddress2: string;
}

interface CreateCustomerThreadBody {
  phone: string;
  senderWorkspaceId: string;
  isActive: boolean;
  customerDetails: {
    name: string;
    companyName: string;
    distributorCode: string;
  };
}
export interface CreateCustomerThreadRequest {
  workspaceId: string;
  body: CreateCustomerThreadBody[];
}

export interface CreateThread {
  sellerWorkspaceId: string;
  inviteIds: string[];
}

export enum IssueStatus {
  ASSIGNED = 'assigned',
  OPEN = 'open',
  CLOSED = 'closed',
}

export interface ThreadFiltersRequest {
  workspaceId: string;
  body: {
    filter: {
      channelType: string | string[];
      status?: Record<string, string[]>;
    };
  };
  params: {
    sellerWorkspaceId: string;
  };
}
export interface RouteNode {
  count: number;
  children: {
    [key: string]: RouteNode;
  };
}

export interface Routes {
  Routes: RouteNode;
}

export interface ThreadFilterResponse {
  cfas?: ThreadFilterCfa[];
  members?: ThreadFilterTeamMember[];
  divisions?: ThreadFilterDivision[];
  statusFilter?: ThreadStatusFilter;
  status?: ThreadFilterStatus;
  routes?: GroupData;
  customerSegment?: GroupData;
  dynamicSegment?: GroupData;
  customerLifeCycle?: GroupData;
  issueStatus?: string[];
  transactionType?: string[];
  customers?: ThreadFilterCustomer[];
  channelType: any[];
  customerStatus?: Record<string, number>;
  whatsapp?: Record<string, number>;
  type?: Record<string, number>;
}

export type GroupData = Record<string, GroupDataNode>;

interface GroupDataNode {
  count: number;
  children: {
    [key: string]: GroupDataNode;
  };
}

interface ThreadFilterCustomer {
  inviteId: string;
  distributorCode: string;
  name: string;
}

interface ThreadFilterStatus {
  Campaign: string[];
  Order: string[];
  Payment: string[];
  Invoice: string[];
  Dispatch: string[];
  Issue: string[];
}

export interface ThreadStatusFilter {
  Campaign: Record<string, number>;
  Order: Record<string, number>;
  Payment: Record<string, number>;
  Invoice: Record<string, number>;
  Dispatch: Record<string, number>;
  Issue: Record<string, number>;
}

interface ThreadFilterDivision {
  id: string;
  name: string;
  code: string;
}

interface ThreadFilterTeamMember {
  inviteId: string;
  employeeCode: string;
  employeeName: null | string;
}

interface ThreadFilterCfa {
  cfaCode: string;
  id: string;
  name: string;
}

export interface ThreadsListRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  body: ThreadsListBody;
}

export interface ThreadsListBody {
  filter: ThreadsFilterRequest;
  searchAfterTimestamp?: null | number;
  lastChannelId?: string;
  pageSize?: number;
}

export interface ThreadsFilterRequest {
  channelType: string[] | string;
  teamMemberIds?: string[];
  divisionIds?: string[];
  cfaIds?: string[];
  status?: ThreadStatusFilterRequest;
  customers?: string[];
  routes?: string[];
  customerSegment?: string[];
  dynamicSegment?: string[];
  customerLifeCycle?: string[];
  type?: string[];
  customerStatus?: string[];
  whatsapp?: string[];
}

export interface ThreadStatusFilterRequest {
  Campaign?: string[];
  Order?: string[];
  Payment?: string[];
  Invoice?: string[];
  Dispatch?: string[];
  transactionType?: string[];
}

export interface ThreadsListResponse {
  channels: ThreadListChannel[];
  statusFilter: ThreadStatusFilter;
}

export interface ThreadListChannel {
  latestMessageTimeToken?: string;
  name: string;
  latestMessage?: string;
  id: string;
  customer?: ThreadListCustomer;
  visitedAt?: string;
  tags?: ThreadListTags[];
  optedOut?: boolean;
  channelSubType?: string;
  channelType?: string;
  conversationTags?: string[];
  messageCountAfterVisited?: number;
}

export type ThreadTagTypes =
  | 'campaign'
  | 'order'
  | 'invoice'
  | 'payment'
  | 'priceList'
  | 'dispatch';

export interface ThreadListTags {
  type: ThreadTagTypes;
  value: string;
}

interface ThreadListCustomer {
  name: string;
  distributorCode: string;
  id: string;
  isActive: number;
}
export interface ThreadsFitlers {
  transactionStatus: Record<string, string[]>;

  // campaign: string[];
  // dispatch: string[];
  // invoice: string[];
  // order: string[];
  // payment: string[];
  // priceList: string[];
  // };

  teamMember: string[];
  customer: string[];
  channelType: string[];
  cfaList: string[];
  divisionList: string[];
  issueThreadTransaction: string[];
  filteredChannels: string[] | null;
  routes: string[];
  customerSegment: string[];
  customerLifeCycle?: string[];
  dynamicSegment?: string[];
  others: {
    Type: string[];
    Status: string[];
    Dispatch: string[];
    Whatsapp: string[];
  };
}

export interface SegmentNode {
  count: number;
  children: { [key: string]: SegmentNode };
}

export interface CustomerSegmentTreeProps {
  node: SegmentNode;
  nodeName: string;
  selectedChannelIds: string[];
  toggleChecked: (id: string, checked: boolean) => void;
  level?: number;
}

export const threadsFiltersInitialState = {
  transactionStatus: {},
  teamMember: [],
  cfaList: [],
  divisionList: [],
  channelType: [],
  customer: [],
  customerSegment: [],
  customerLifeCycle: [],
  dynamicSegment: [],
  routes: [],
  issueThreadTransaction: [],
  filteredChannels: null,
  others: {
    Type: [],
    Status: [],
    Dispatch: [],
    Whatsapp: [],
  },
};

export interface AddMessageReactionRequest {
  body: {
    channel: string;
    messageTimetoken: string | number;
    type: string;
    value: string;
    messageId: string;
    waConfigId: string;
    actionTimeTokenForLastAction?: string | undefined;
  };
  params: {
    sellerWorkspaceId: string;
  };
}

export interface AddMessageReactionResponse {}

export interface UpdateThreadLastVisitRequest {
  sellerWorkspaceId: string;
  channels: string[];
}

export interface ThreadLastVisitResponseData {
  createdAt: string;
  channelId: string;
  timetoken: string;
  userId: string;
  updatedAt: string;
}

export enum GroupSubTypeEnum {
  SINGLE_THREAD = 'THS',
  GROUP_THREAD = 'THG',
  ISSUE_THREAD = 'THT',
  ZO_AI = 'ZoAI',
  WHATSAPP = 'WA',

  //WAHA SUBTYPES
  MKTG = 'MKTG',
  CUST = 'CUST',
  INT = 'INT',
  NONB = 'NONB',

  CAPI = 'CAPI',
  BRODCAST = 'BROD',
}

export enum GroupTypeEnum {
  CUSTOMER = 'C',
  TEAM = 'T',
  THREAD = 'TH',
  APP = 'A',
  FOLDER = 'F',
  WAHA = 'WAHA',
  WAGR = 'WAGR',
}

export interface CreateGroupRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    workspaceId: string;
    id?: string;
    customerId?: string;
    channelName?: string;
    channelType?: GroupTypeEnum;
    channelSubType?: GroupSubTypeEnum;
    description?: string;
    forceUpdate?: boolean;
    groupMembers?: {
      members?: {
        mobile?: string;
        role: string;
        displayName: string;
        teamMemberId?: string;
        customerId?: string;
      }[];
    };
  };
}

export interface CreateGroupResponse {}

export interface UpdateGroupMembersRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    channelId: string;
    workspaceId: string;
    groupMembers?: {
      inviteDetailsUpdate?: any;
      updateMembers?: {
        teamMemberId?: string;
        customerId?: string;
        mobile?: string;
        role?: string;
        displayName?: string;
        id?: string;
      }[];
      deleteMembers?: {
        id: string;
      }[];
    };
  };
}

export interface UpdateGroupMembersResponse {}
